import { defineStore } from "pinia";
import _ from "lodash";
import { FetchState } from "@/shared/types";
import { WexProxyState } from "@/admin/types";
import { useNotifierStore } from "@/shared/store/notifier";
import * as storeHelper from "@/shared/storeHelper";
import * as wexProxyService from "@/shared/api/wexProxyService";

export const initialState: WexProxyState = {
    statusFileFetchState: FetchState.Uninitialized,
};

export const useWexProxyStore = defineStore("wexProxy", {
    state: () => (_.cloneDeep(initialState)),
    getters: {
        statusFileProcessing: state => state.statusFileFetchState === FetchState.Loading,
    },
    actions: {
        setStatusFileFetchState (fetchState: FetchState) {
            this.statusFileFetchState = fetchState;
        },
        processLegacyStatusesFile ({  csv }) {
            return wexProxyService.processHsaAccountStatusesFile(csv)
                .then(response => {
                    this.setStatusFileFetchState(FetchState.Uninitialized);
                    const data = response.data;
                    const notifierStore = useNotifierStore();
                    const successText = "HSA Account Status Update file processing complete."
                        + "<br/>Total: " + data.total;
                    notifierStore.setSuccess(successText);
                })
                .catch(err => storeHelper.handleError({ error: err, rethrow: true }));
        },
    }
});